'use strict'

import Vimeo from '@vimeo/player';
import 'jquery.flipster';

export default class Gallery {
    constructor() {
        this.running = false;
        this.activeIndex = 0;
        this.items = [];
        $('.gallery_content').each((i,e) => {
            const element = $(e);
            if (element.hasClass('video')) {
                this.items.push(new GalleryVideo(element));
            } else {
                this.items.push(new GalleryItem(element));
            }
        });
        this.items.forEach((e,i) => {
            e.detach();
        });
        this.createGalleryElements();
        this.createEvents();

        window.staticEvents.addListener('resize',() => { this.resize(); });

        this.start();
        //setTimeout(() => {
            //this.next(4);
        //},1000);
    }
    getElementIndeces() {
        return [
            (this.activeIndex-2+this.items.length)%this.items.length,
            (this.activeIndex-1+this.items.length)%this.items.length,
            this.activeIndex,
            (this.activeIndex+1)%this.items.length,
            (this.activeIndex+2)%this.items.length
        ];
    }
    createGalleryElements() {
        const elementIndeces = this.getElementIndeces();
        this.items.forEach((e,i) => {
            const childIndex = elementIndeces.findIndex((el) => {
                return el === i;
            });
            // in any case, remove click events
            e.element.off("click");
            if (childIndex < 0 ) {
                e.element.removeClass('child_0');
                e.element.removeClass('child_1');
                e.element.removeClass('child_2');
                e.element.removeClass('child_3');
                e.element.removeClass('child_4');
                e.detach();
            }
        });
        elementIndeces.forEach((elementIndex,childIndex) => {
           const e = this.items[elementIndex];
           switch (childIndex) {
               case 0: {
                   e.element.on("click",() => {
                       this.next(-2);
                   });
                   break;
               }
               case 1: {
                   e.element.on("click",() => {
                       this.next(-1);
                   });
                   break;
               }
               case 2: {
                   // haha, hoho
                   break;
               }
               case 3: {
                   e.element.on("click",() => {
                       this.next(1);
                   });
                   break;
               }
               case 4: {
                   e.element.on("click",() => {
                       this.next(2);
                   });
                   break;
               }
           }
           if (e.isAttached()) {
               e.element.removeClass('child_0');
               e.element.removeClass('child_1');
               e.element.removeClass('child_2');
               e.element.removeClass('child_3');
               e.element.removeClass('child_4');
               e.element.addClass(`child_${childIndex}`);
           } else {
               e.appendTo($('.gallery'),childIndex);
           }
        });
        this.setDynamicCSS();
    }
    getChildWidth(childIndex, factor) {
        const child = $(`.child_${childIndex}`);
        if (child.hasClass('video')) {
            const video = child.find('.video');
            //const iframe = video.find('iframe');
            const wwww = video.attr('data-ratio') === '43' ? 120 : 160;
            return childIndex == 0 | childIndex == 4 ? wwww + 4
             : childIndex == 1 | childIndex == 3 ? wwww * 1.4 + 4
             : wwww * 3 + 4;
        } else {
           return factor * parseFloat(child.attr('data-ratio')) + 4; 
        }
    }
    setDynamicCSS() {
        const center = $('.gallery').first().width()/2;
        const galleryHeight = $('.gallery').height();
        const videoHeight_3 = galleryHeight * 0.75;
        const videoHeight_4 = galleryHeight * 0.5;
        //const childWidth_0 = this.getChildWidth(0,galleryHeight * 0.5);
        //const childWidth_1 = this.getChildWidth(1,galleryHeight * 0.75);
        const childWidth_2 = this.getChildWidth(2,galleryHeight * 0.9);
        const childWidth_3 = this.getChildWidth(3,galleryHeight * 0.75);
        const childWidth_4 = this.getChildWidth(4,galleryHeight * 0.5);
        const paddingWidth = (center - (childWidth_2/2)) / 3;

        const videoWidth_3 = videoHeight_3 * (16.0/9.0) * 1.0;
        const videoWidth_3_43 = videoHeight_3 * (4.0/3.0);
        const videoWidth_4 = videoHeight_4 * (16.0/9.0) * 1.0;
        const videoWidth_4_43 = videoHeight_4 * (4.0/3.0) * 1.0;

        if ($('#dynamicCSS').length <= 0) {
            $("head").append('<style id="dynamicCSS" type="text/css"></style>');
        }

        let dynamicCSS = `
            /***************************************************************** CHILD 0 */
            .container.middle .gallery .gallery_content.child_0 {
                   left: ${(center-childWidth_2/2)-paddingWidth*2}px;
            } 
            .container.middle .gallery .gallery_content.child_0 .video {
                   max-width: ${paddingWidth}px;
            } 
            .container.middle .gallery .gallery_content.child_0 .video iframe {
                   min-width: ${videoWidth_4}px;
                   min-height: ${videoHeight_4}px;
                   max-width: ${videoWidth_4}px;
                   max-height: ${videoHeight_4}px;
            } 
            .container.middle .gallery .gallery_content.child_0 .video.ratio43 iframe {
                   min-width: ${videoWidth_4_43}px;
                   max-width: ${videoWidth_4_43}px;
            } 

            /***************************************************************** CHILD 1 */
            .container.middle .gallery .gallery_content.child_1 {
                   left: ${(center-childWidth_2/2)-paddingWidth}px;
            } 
            .container.middle .gallery .gallery_content.child_1 .video {
                   max-width: ${paddingWidth}px;
            } 
            .container.middle .gallery .gallery_content.child_1 .video iframe {
                   min-width: ${videoWidth_3}px;
                   min-height: ${videoHeight_3}px;
                   max-width: ${videoWidth_3}px;
                   max-height: ${videoHeight_3}px;
            } 
            .container.middle .gallery .gallery_content.child_1 .video.ratio43 iframe {
                   min-width: ${videoWidth_3_43}px;
                   max-width: ${videoWidth_3_43}px;
            } 

            /***************************************************************** CHILD 2 */
            .container.middle .gallery .gallery_content.child_2 {
                   left: ${(center-childWidth_2/2)}px;
            } 
            .container.middle .gallery .gallery_content.child_2 .video {
                   min-width: ${childWidth_2}px;
                   max-width: ${childWidth_2}px;
            } 
            .container.middle .gallery .gallery_content.child_2.video {
                   min-width: ${childWidth_2}px;
                   max-width: ${childWidth_2}px;
            } 
            .container.middle .gallery .gallery_content.child_2 .video iframe {
                   min-width: ${childWidth_2}px;
                   max-width: ${childWidth_2}px;
            } 
            .container.middle .gallery .gallery_content.child_2 .video.ratio43 iframe {
                   min-width: ${childWidth_2}px;
                   max-width: ${childWidth_2}px;
            } 

            /***************************************************************** CHILD 3 */
            .container.middle .gallery .gallery_content.child_3 {
                   left: ${(center+childWidth_2/2-childWidth_3)+paddingWidth}px;
            } 
            .container.middle .gallery .gallery_content.child_3.video {
                   left: ${(center+childWidth_2/2-paddingWidth)+paddingWidth}px;
            } 
            .container.middle .gallery .gallery_content.child_3 .video {
                   max-width: ${paddingWidth}px;
            } 
            .container.middle .gallery .gallery_content.child_3 .video iframe {
                   min-width: ${videoWidth_3}px;
                   min-height: ${videoHeight_3}px;
                   max-width: ${videoWidth_3}px;
                   max-height: ${videoHeight_3}px;
            } 
            .container.middle .gallery .gallery_content.child_3 .video.ratio43 iframe {
                   min-width: ${videoWidth_3_43}px;
                   max-width: ${videoWidth_3_43}px;
            } 

            /***************************************************************** CHILD 4 */
            .container.middle .gallery .gallery_content.child_4 {
                   left: ${(center+childWidth_2/2-childWidth_4)+paddingWidth*2}px;
            } 
            .container.middle .gallery .gallery_content.child_4.video {
                   left: ${(center+childWidth_2/2-paddingWidth)+paddingWidth*2}px;
            } 
            .container.middle .gallery .gallery_content.child_4 .video {
                   max-width: ${paddingWidth}px;
            } 
            .container.middle .gallery .gallery_content.child_4 .video iframe {
                   min-width: ${videoWidth_4}px;
                   min-height: ${videoHeight_4}px;
                   max-width: ${videoWidth_4}px;
                   max-height: ${videoHeight_4}px;
            } 
            .container.middle .gallery .gallery_content.child_4 .video.ratio43 iframe {
                   min-width: ${videoWidth_4_43}px;
                   max-width: ${videoWidth_4_43}px;
            } 
        `;

        $('#dynamicCSS').html(dynamicCSS);
    }
    createEvents() {
        $('.gallery').hover(() => {
            this.stop();
        }, () => {
            this.start();
        });
        $('.btn_gallery.btn_l').click(() => {
            this.next(-1);
        });
        $('.btn_gallery.btn_r').click(() => {
            this.next(1);
        });
    }
    start() {
        if (!this.running) {
            this.running = true;
            this.interval = setInterval(() => {
                this.next();
            }, 6000);
        }
    }
    next(direction=1) {
        const active = this.items[this.activeIndex];
        const nextIndex = (this.activeIndex+direction+this.items.length)%this.items.length;

        this.handover = () => {
            active.off("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd",this.handover);
            this.activeHandover = false;
        }
        active.on("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", this.handover);
        this.activeIndex = nextIndex;
        this.createGalleryElements();
        this.activeHandover = true;
        window.staticEvents.emit('trackEvent',['gallery','flip',`show frame ${this.activeIndex}`]);
    }
    stop() {
        const active = this.items[this.activeIndex];
        clearInterval(this.interval);
        if (this.activeHandover === true) {
            active.off("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd",this.handover);
            this.activeHandover = false;
        }
        //this.items.forEach((e,i) => {
            //if (i !== this.activeIndex && e.isAttached()) {
                //e.detach();
            //}
        //});
        this.running = false;
    }
    resize() {
        this.setDynamicCSS();
    }
}

class GalleryItem {
    constructor(element) {
        this.element = element;
        this.attached = true;
        this.element.find('a').first().click(() => {
            window.staticEvents.emit('trackEvent',['gallery','open',`open link ${this.element.attr('data-title')}`]);
        });
    }
    detach() {
        this.element.detach();
        this.attached = false;
    }
    appendTo(target, index=0) {
        this.element.addClass(`child_${index}`);
        this.element.appendTo(target);
        this.attached = true;
        const title = this.element.attr('data-title');
    }
    width() {
        return this.element.width();
    }
    css(a,b) {
        this.element.css(a,b);
    }
    on(a,b) {
        this.element.on(a,b);
    }
    off(a,b) {
        this.element.off(a,b);
    }
    isAttached() {
        return this.attached;
    }
}
class GalleryVideo extends GalleryItem {
    constructor(element) {
        super(element);
        //clearTimeout(this.timeout);
        //this.timeout = setTimeout(() => {
            const e = element.children('.video'); 
            const vimeoId = e.attr('data-imeo-id');
            const widthRatio = e.attr('data-ratio') === '43' ? 1.0 : 1.0;
            const heightRatio = e.attr('data-ratio') === '43' ? 0.75 : 0.5625;
            const scaleRatio = e.attr('data-ratio') === '43' ? 0.5 : 0.8;
            
            e.addClass(`ratio${e.attr('data-ratio')}`);

            let width = $('.gallery').width() * widthRatio;
            const options = {
                id: vimeoId,
                byline: false,
                portrait: false,
                color: 'ffffff',
                title: true
            };
            this.player = new Vimeo(e.attr('id'), options);
            //setTimeout(() => {
                //e.children('iframe').hover((el) => {
                    //width = $('.gallery').width() * widthRatio;
                    //$(el.currentTarget).css('max-width',`${width}px`);
                    //$(el.currentTarget).css('max-height',`${width * heightRatio}px`);
                //}, (el) => {
                    //width = $('.gallery').width() * widthRatio;
                    //$(el.currentTarget).css('max-width',`${width * scaleRatio}px`);
                    //$(el.currentTarget).css('max-height',`${width * scaleRatio * heightRatio}px`);
                //});
                //width = $('.gallery').width() * widthRatio;
                //e.children('iframe').css('max-width',`${width * scaleRatio}px`);
                //e.children('iframe').css('max-height',`${width * scaleRatio * heightRatio}px`);
            //}, 1000);
            //e.children('iframe').css('max-width',`${width * scaleRatio}px`);
            //e.children('iframe').css('max-height',`${width * scaleRatio * heightRatio}px`);
        //},100000);
        this.player.on('play',() => {
            window.staticEvents.emit('trackEvent',['gallery','open',`play video ${this.element.attr('data-title')}`]);
        });
    }
    detach() {
        //clearTimeout(this.timeout);
        super.detach();
    }
}
